
import { BUSINESS_UNIT_ADDRESS_METADATA } from './business-unit-address.metadata';
import { BusinessUnitAddress } from './business-unit-address.model';
import { BusinessUnitEntityDecorator } from './business-unit.decorator';
import { BusinessUnit } from './business-unit.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class BusinessUnitAddressEntityDecoratorBase extends GenericEntityDecorator<BusinessUnitAddress, number> {
  constructor() {
    super(BUSINESS_UNIT_ADDRESS_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.businessUnitAddressId == null) {
      return null;
    }
    return parseInt(params.businessUnitAddressId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: BusinessUnitAddress): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




